import { Injectable } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';

import { AddReasonCodeModalComponent } from './add-reason-code-modal.component';

@Injectable()
export class AddReasonCodeModalService {
    constructor(private readonly dialog: MatDialog) { }

    showModal() {
        let dialogRef: MatDialogRef<AddReasonCodeModalComponent>;

        dialogRef = this.dialog.open(
            AddReasonCodeModalComponent,
            {
                height: '360px',
                disableClose: true,
            }
        );

        return dialogRef;
    }
}
